(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tendenzo-customer-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tendenzo-customer-reviews')) {
    customElements.define('tendenzo-customer-reviews', class extends HTMLElement {
      connectedCallback() { this.addEventListener('click', this.onClick); }
      disconnectedCallback() { this.removeEventListener('click', this.onClick); }
      onClick = (event) => {
        const button = event.target.closest('[data-direction]');
        if (!button) return;
        const track = this.querySelector('.tendenzo-customer-reviews__track');
        const card = track.querySelector('article');
        if (!card) return;
        track.scrollBy({ left: Number(button.dataset.direction) * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tendenzo-info-bullets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tendenzo-demo-viewers')) {
    customElements.define('tendenzo-demo-viewers', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.timer);
        const first = Number(this.dataset.min) || 8;
        const second = Number(this.dataset.max) || 18;
        const min = Math.min(first, second);
        const max = Math.max(first, second);
        const count = this.querySelector('[data-viewer-count]');
        this.timer = setInterval(() => {
          if (document.hidden || !count) return;
          const current = Number(count.textContent);
          let next = min + Math.floor(Math.random() * (max - min + 1));
          if (next === current && max > min) next = next === max ? min : next + 1;
          count.textContent = String(next);
        }, 8000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
